import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 3v12","key":"svg-0"}],["path",{"d":"M16 11l-4 4l-4 -4","key":"svg-1"}],["path",{"d":"M3 12a9 9 0 0 0 18 0","key":"svg-2"}]]

const IconArrowDownToArc = createReactComponent('outline', 'arrow-down-to-arc', 'ArrowDownToArc', __iconNode);

export default IconArrowDownToArc;